import { instance } from "./index";


export const Login = async (payload) => {
    const response = await instance.post(`/user/login`, payload)
    return response.data;
};

export const refreshUserToken = async (payload) => {
    const response = await instance.post(`/user/refresh-token`, payload)
    return response.data;
}

export const forgetPassword = async (payload) => {
    const response = await instance.post(`/user/forget-password`, payload)
    return response.data;
}

export const resetPassword = async (payload) => {
    const response = await instance.post(`/user/reset-password`, payload)
    return response.data;
}
  

export const validateResetToken = async (payload) => {
    const response = await instance.post(`/user/validate-reset-token`, payload)
    return response.data;
}

export const validateCompleteProfileToken = async (payload) => {
    const response = await instance.post(`/user/validate-complete-profile-token`, payload)
    return response.data;

}

export const completeProfile = async (payload) => {
  const response = await instance.post(`/user/complete-profile`, payload)
  return response.data;
};

export const updateProfile = async (id, payload) => {
  const response = await instance.put(`/user/update-profile/${id}`, payload)
  return response.data;
};

export const adminGetAllUsers = async (page = 1, limit = 10, searchText = '') => {
  const response = await instance.get('/users/all', {
    params: { page, limit, searchText }
  });
  return response.data;
};

export const createCustomer = async (payload) => {
  const response = await instance.post(`/user/create-user`, payload)
  return response.data;
};

export const updateCustomerTax = async (id, payload) => {
  const response = await instance.put(`/user/update-user-tax/${id}`, payload)
  return response.data;
};

export const updateUserApiLimits = async (id, payload) => {
  const response = await instance.put(`/user/update-api-limits/${id}`, payload)
  return response.data;
};

export const adminUpdatePartnerConfig = async (id, payload) => {
  const response = await instance.patch(`/user/admin/${id}/partner-config`, payload);
  return response.data;
};

export const deleteCustomers = async (ids) => {
  const response = await instance.post(`/user/delete-users`, { ids })
  return response.data;
};

export const changeCustomerStatus = async (id, payload) => {
  const response = await instance.put(`/user/update-status/${id}`, payload)
  return response.data;
};



// application apis

export const createApplication = async (payload) => {
  const response = await instance.post(`/application/create`, payload);
  return response.data;
};

export const updateApplication = async (id, payload) => {
  const response = await instance.put(`/application/update/${id}`, payload);
  return response.data;
};

export const getApplicationById = async (id) => {
  const response = await instance.get(`/application/${id}`);
  return response.data;
};

export const adminDeleteApplication = async (ids) => {
  const response = await instance.post(`/applications/admin/delete`, { ids });
  return response.data;
};

export const fetchAllApplications = async (page = 1, limit = 10, searchText = '') => {
  const response = await instance.get('/applications/all', {
    params: { page, limit, searchText }
  });
  return response.data;
};

// `extra` is optioneel: { partner: true, toInvoice: true } voor de
// partner-filters op de subsidie-lijsten (contract 5). Oude aanroepen met
// vijf argumenten blijven ongewijzigd werken.
export const adminFetchAllApplications = async (page = 1, limit = 10, searchText = '', regling = '', view, extra = {}) => {
  const response = await instance.get('/applications/admin/all', {
    params: {
      page,
      limit,
      searchText,
      regling,
      view,
      partner: extra?.partner ? 1 : undefined,
      toInvoice: extra?.toInvoice ? 1 : undefined,
    }
  });
  return response.data;
};

// Partner-portaal (customer-side): subsidie-aanvragen die via de partner-link
// van deze klant zijn binnengekomen. Read-only, geen PII (contract 4).
export const customerFetchPartnerSubsidieApplications = async ({
  page = 1,
  limit = 25,
  regling = '',
  search = '',
} = {}) => {
  const response = await instance.get('/applications/customer/partner-list', {
    params: {
      page,
      limit,
      regling: regling || undefined,
      search: search || undefined,
    },
  });
  return response.data;
};

export const adminUpdateApplicationStatus = async (id, payload) => {
  const response = await instance.put(`/application/admin/update/${id}`, payload);
  return response.data;
};

// BTW battery applications
export const adminFetchBtwApplications = async ({
  page = 1,
  limit = 25,
  status = '',
  qualificationStatus = '',
  installateur = '',
  archived = '',
  workflowStatusId = '',
  assignedToAdminId = '',
  unassigned = false,
  mine = false,
  stuck = false,
  awaitingPartnerPayment = false,
  toInvoice = false,
  labelId = '',
  deadline = '',
  search = '',
  sort = '',
} = {}) => {
  const response = await instance.get('/btw-applications/admin/all', {
    params: {
      page,
      limit,
      status,
      qualificationStatus,
      installateur,
      archived,
      workflowStatusId,
      assignedToAdminId,
      unassigned: unassigned || undefined,
      mine: mine || undefined,
      stuck: stuck || undefined,
      awaitingPartnerPayment: awaitingPartnerPayment || undefined,
      toInvoice: toInvoice || undefined,
      labelId: labelId || undefined,
      deadline: deadline || undefined,
      search: search || undefined,
      sort: sort || undefined,
    },
  });
  return response.data;
};

export const adminFetchBtwApplicationById = async (id) => {
  const response = await instance.get(`/btw-applications/admin/${id}`);
  return response.data;
};

export const adminArchiveBtwApplication = async (id, archive = true) => {
  const response = await instance.patch(`/btw-applications/admin/${id}/archive`, { archive });
  return response.data;
};

export const adminDeleteBtwApplication = async (id) => {
  const response = await instance.patch(`/btw-applications/admin/${id}/delete`);
  return response.data;
};

export const adminUpdateBtwWorkflowStatus = async (id, workflowStatusId, comment = '') => {
  const response = await instance.patch(`/btw-applications/admin/${id}/workflow-status`, {
    workflowStatusId,
    comment,
  });
  return response.data;
};

export const adminUpdateBtwAssignee = async (id, assignedToAdminId, comment = '') => {
  const response = await instance.patch(`/btw-applications/admin/${id}/assignee`, {
    assignedToAdminId,
    comment,
  });
  return response.data;
};

export const adminUpdateBtwDeadline = async (id, { deadlineAt, deadlineNote, reminderSchedule }) => {
  const response = await instance.patch(`/btw-applications/admin/${id}/deadline`, {
    deadlineAt,
    deadlineNote,
    reminderSchedule,
  });
  return response.data;
};

export const adminAddBtwComment = async (id, body) => {
  const response = await instance.post(`/btw-applications/admin/${id}/comment`, { body });
  return response.data;
};

export const adminEditBtwComment = async (id, commentId, body) => {
  const response = await instance.patch(
    `/btw-applications/admin/${id}/comment/${commentId}`,
    { body },
  );
  return response.data;
};

export const adminDeleteBtwComment = async (id, commentId) => {
  const response = await instance.delete(
    `/btw-applications/admin/${id}/comment/${commentId}`,
  );
  return response.data;
};

// BTW aanvraag details bewerken
export const adminUpdateBtwDetails = async (id, payload) => {
  const response = await instance.patch(
    `/btw-applications/admin/${id}/details`,
    payload,
  );
  return response.data;
};

// BTW file management
export const adminAddBtwFile = async (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const response = await instance.post(
    `/btw-applications/admin/${id}/files`,
    fd,
  );
  return response.data;
};

export const adminReplaceBtwInvoice = async (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const response = await instance.patch(
    `/btw-applications/admin/${id}/files/invoice`,
    fd,
  );
  return response.data;
};

export const adminDeleteBtwInvoice = async (id) => {
  const response = await instance.delete(
    `/btw-applications/admin/${id}/files/invoice`,
  );
  return response.data;
};

export const adminDeleteBtwOtherFile = async (id, publicId) => {
  const response = await instance.delete(
    `/btw-applications/admin/${id}/files/other/${encodeURIComponent(publicId)}`,
  );
  return response.data;
};

export const adminConfirmBtwInvoicePaid = async (id, { confirmed = true, file = null } = {}) => {
  const fd = new FormData();
  fd.append('confirmed', confirmed ? 'true' : 'false');
  if (file) fd.append('file', file);
  const response = await instance.patch(
    `/btw-applications/admin/${id}/invoice-paid`,
    fd,
  );
  return response.data;
};

export const adminDownloadBtwMachtigingPdf = async (id) => {
  const response = await instance.get(
    `/btw-applications/admin/${id}/machtiging-pdf`,
    { responseType: 'blob' },
  );
  return response.data;
};

// Belastingdienst-formulier ON0202 bij een BTW-aanvraag. De preview levert de
// berekende veldwaarden + waarschuwingen; de PDF wordt per download opnieuw
// gegenereerd en nergens opgeslagen (er staat een BSN in).
// POST hoewel het een leesactie is: de overrides bevatten de klantnaam en die
// hoort niet in een URL (access-logs, proxies, browsergeschiedenis).
export const adminFetchBelastingdienstForm = async (id, overrides = {}) => {
  const response = await instance.post(
    `/btw-applications/admin/${id}/belastingdienst-form`,
    overrides,
  );
  return response.data;
};

// Het opgeslagen formulier staat afgeschermd op Cloudinary; de server haalt het
// op en stuurt de bytes door, zodat de link nooit buiten de login komt.
export const adminDownloadBelastingdienstFormFile = async (id) => {
  const response = await instance.get(
    `/btw-applications/admin/${id}/belastingdienst-form-file`,
    { responseType: 'blob' },
  );
  return response.data;
};

export const adminDownloadBelastingdienstPdf = async (id, overrides = {}) => {
  const response = await instance.post(
    `/btw-applications/admin/${id}/belastingdienst-pdf`,
    overrides,
    { responseType: 'blob' },
  );
  return response.data;
};

// Variabelen + berekening voor klantmails (en het blok "Berekening teruggave").
export const adminFetchBtwMailContext = async (id) => {
  const response = await instance.get(`/btw-applications/admin/${id}/mail-context`);
  return response.data;
};

export const adminSendBtwCustomerEmail = async (id, { subject, body, toEmail }) => {
  const response = await instance.post(
    `/btw-applications/admin/${id}/send-customer-email`,
    { subject, body, toEmail },
  );
  return response.data;
};

// ────────────────────────────────────────────────────────────────────────────
// BTW Mail-templates (admin)
// ────────────────────────────────────────────────────────────────────────────

export const adminFetchBtwEmailTemplates = async ({ includeArchived = false } = {}) => {
  const response = await instance.get('/btw-email-templates/admin/all', {
    params: { includeArchived: includeArchived || undefined },
  });
  return response.data;
};

export const adminCreateBtwEmailTemplate = async (payload) => {
  const response = await instance.post('/btw-email-templates/admin', payload);
  return response.data;
};

export const adminUpdateBtwEmailTemplate = async (id, payload) => {
  const response = await instance.patch(`/btw-email-templates/admin/${id}`, payload);
  return response.data;
};

export const adminArchiveBtwEmailTemplate = async (id, archive = true) => {
  const response = await instance.patch(
    `/btw-email-templates/admin/${id}/archive`,
    { archive },
  );
  return response.data;
};

// ────────────────────────────────────────────────────────────────────────────
// BTW Labels (admin)
// ────────────────────────────────────────────────────────────────────────────

export const adminFetchBtwLabels = async ({ includeArchived = false } = {}) => {
  const response = await instance.get('/btw-labels/admin/all', {
    params: { includeArchived: includeArchived || undefined },
  });
  return response.data;
};

export const adminCreateBtwLabel = async (payload) => {
  const response = await instance.post('/btw-labels/admin', payload);
  return response.data;
};

export const adminUpdateBtwLabel = async (id, payload) => {
  const response = await instance.patch(`/btw-labels/admin/${id}`, payload);
  return response.data;
};

export const adminArchiveBtwLabel = async (id, archive = true) => {
  const response = await instance.patch(`/btw-labels/admin/${id}/archive`, {
    archive,
  });
  return response.data;
};

export const adminSetBtwApplicationLabels = async (id, labelIds) => {
  const response = await instance.patch(
    `/btw-applications/admin/${id}/labels`,
    { labelIds },
  );
  return response.data;
};

// BTW workflow-statussen (beheer)
export const adminFetchBtwStatuses = async ({ includeArchived = false } = {}) => {
  const response = await instance.get('/btw-statuses/admin/all', {
    params: { includeArchived: includeArchived || undefined },
  });
  return response.data;
};

export const adminCreateBtwStatus = async (payload) => {
  const response = await instance.post('/btw-statuses/admin', payload);
  return response.data;
};

export const adminUpdateBtwStatus = async (id, payload) => {
  const response = await instance.patch(`/btw-statuses/admin/${id}`, payload);
  return response.data;
};

export const adminArchiveBtwStatus = async (id, { archive = true, reassignTo } = {}) => {
  const response = await instance.patch(`/btw-statuses/admin/${id}/archive`, {
    archive,
    reassignTo,
  });
  return response.data;
};

export const adminReorderBtwStatuses = async (items) => {
  const response = await instance.patch('/btw-statuses/admin/reorder', { items });
  return response.data;
};

// Admins (for assignee dropdown)
export const adminFetchAdmins = async () => {
  const response = await instance.get('/users/admins');
  return response.data;
};



// invoice apis

export const fetchAllInvoices = async (page = 1, limit = 10, searchText = '') => {
  const response = await instance.get('/invoices/all', {
    params: { page, limit, searchText }
  });
  return response.data;
};
export const adminDeleteInvoice = async (ids) => {
  const response = await instance.post(`/invoices/admin/delete`, { ids });
  return response.data;
};

export const adminUpdateInvoiceStatus = async (id, payload) => {
  const response = await instance.put(`/invoice/admin/update/${id}`, payload);
  return response.data;
};

export const getInvoiceById = async (id) => {
  const response = await instance.get(`/invoice/${id}`);
  return response.data;
};

export const getAllUserInvoices = async (page = 1, limit = 10, searchText = '') => {
  const response = await instance.get('/invoices/user/all', {
    params: { page, limit, searchText }
  });
  return response.data;

}

// dashboard apis
export const fetchDashboardData = async () => {
  const response = await instance.get(`/admin/dashboard-data/`);
  return response.data;
}

export const fetchFinancialsTimeseries = async (range = '12m') => {
  const response = await instance.get(`/admin/financials/timeseries`, {
    params: { range },
  });
  return response.data;
}

// cloudinary apis

export const uploadImage = async (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await instance.post(`/cloudinary/upload${token ? `?token=${token}`: '' }`, formData);
    return response.data;
}

//others 


export const fetchSearchSuggestions = async (type,searchText) => {
  const response = await instance.get(`/search-suggestions`, {
    params: { type, searchText }
  });
  return response.data;
};

export const fetchUserCompanyDetails = async (kvkNumber) => {
  const response = await instance.get(`/user/company-details/${kvkNumber}`);
  return response.data;
}

// ────────────────────────────────────────────────────────────────────────────
// BTW Partner-portaal (customer-side)
// ────────────────────────────────────────────────────────────────────────────

export const customerFetchPartnerBtwApplications = async ({
  page = 1,
  limit = 25,
  search = '',
} = {}) => {
  const response = await instance.get('/btw-applications/customer/partner-list', {
    params: { page, limit, search: search || undefined },
  });
  return response.data;
};

export const customerFetchPartnerBtwApplicationById = async (id) => {
  const response = await instance.get(`/btw-applications/customer/partner/${id}`);
  return response.data;
};

export const customerFetchPartnerInvoices = async ({
  page = 1,
  limit = 25,
} = {}) => {
  const response = await instance.get('/partner-invoices/customer/all', {
    params: { page, limit },
  });
  return response.data;
};

export const customerFetchPartnerInvoiceById = async (id) => {
  const response = await instance.get(`/partner-invoices/customer/${id}`);
  return response.data;
};

export const customerDownloadPartnerInvoicePdf = async (id) => {
  const response = await instance.get(`/partner-invoices/customer/${id}`, {
    params: { download: 'pdf' },
    responseType: 'blob',
  });
  return response.data;
};

// ────────────────────────────────────────────────────────────────────────────
// BTW Partner-facturen (admin)
// ────────────────────────────────────────────────────────────────────────────

export const adminFetchPartnerInvoices = async ({
  page = 1,
  limit = 25,
  partnerUserId = '',
  status = '',
  type = '',
  search = '',
} = {}) => {
  const response = await instance.get('/partner-invoices/admin/all', {
    params: {
      page,
      limit,
      partnerUserId: partnerUserId || undefined,
      status: status || undefined,
      type: type || undefined,
      search: search || undefined,
    },
  });
  return response.data;
};

// `applicationModel` bepaalt uit welke collectie de aanvragen komen:
// 'BtwApplications' (default, BTW-flow) of 'Applications' (subsidie-flow).
export const adminPreviewPartnerInvoice = async ({
  partnerUserId,
  applicationIds,
  applicationModel = 'BtwApplications',
}) => {
  const response = await instance.post('/partner-invoices/admin/preview', {
    partnerUserId,
    applicationIds,
    applicationModel,
  });
  return response.data;
};

export const adminCreatePartnerInvoice = async (payload) => {
  const response = await instance.post('/partner-invoices/admin', payload);
  return response.data;
};

export const adminGetPartnerInvoice = async (id) => {
  const response = await instance.get(`/partner-invoices/admin/${id}`);
  return response.data;
};

export const adminSendPartnerInvoice = async (id, { resend = false } = {}) => {
  const response = await instance.post(`/partner-invoices/admin/${id}/send`, {
    resend,
  });
  return response.data;
};

export const adminMarkPartnerInvoicePaid = async (id, { undo = false, paidAt } = {}) => {
  const response = await instance.patch(`/partner-invoices/admin/${id}/mark-paid`, {
    undo,
    paidAt,
  });
  return response.data;
};

export const adminCreatePartnerCreditNote = async (id, { applicationIds, reason } = {}) => {
  const response = await instance.post(
    `/partner-invoices/admin/${id}/credit-note`,
    { applicationIds, reason },
  );
  return response.data;
};

// Verwijdert concept- of verstuurde facturen (niet betaald/gecrediteerd).
export const adminDeletePartnerInvoice = async (id) => {
  const response = await instance.delete(`/partner-invoices/admin/${id}`);
  return response.data;
};

// Bewerk kopgegevens en/of regels. 'lines' is een volledige vervanging.
export const adminUpdatePartnerInvoice = async (id, payload) => {
  const response = await instance.patch(`/partner-invoices/admin/${id}`, payload);
  return response.data;
};

// Aanvragen van dezelfde partner die nog op deze factuur kunnen.
export const adminFetchPartnerInvoiceCandidates = async (id) => {
  const response = await instance.get(`/partner-invoices/admin/${id}/candidates`);
  return response.data;
};